// Generated by GitHub Copilot
/** A guest submitter identity, as returned by the guest-resolution endpoint. */
export default class GuestIdentity {
  id: string = ''
  display_name: string | null = null
  email: string | null = null
  anonymized: boolean = false
  type = 'guest' as const
}
